var map = {
	"./Boutique.jpg": "./src/assets/project_images/accommodation/Boutique.jpg",
	"./CDCK.jpg": "./src/assets/project_images/accommodation/CDCK.jpg",
	"./COZZI.jpg": "./src/assets/project_images/accommodation/COZZI.jpg",
	"./H2O.png": "./src/assets/project_images/accommodation/H2O.png",
	"./Hotel_Nikko.jpg": "./src/assets/project_images/accommodation/Hotel_Nikko.jpg",
	"./Hotel_dua.jpg": "./src/assets/project_images/accommodation/Hotel_dua.jpg",
	"./Howard.jpg": "./src/assets/project_images/accommodation/Howard.jpg",
	"./Indigo.jpg": "./src/assets/project_images/accommodation/Indigo.jpg",
	"./InterContinental.jpg": "./src/assets/project_images/accommodation/InterContinental.jpg",
	"./KaohsiungTaiUrbanResort.jpg": "./src/assets/project_images/accommodation/KaohsiungTaiUrbanResort.jpg",
	"./SilksClub.jpg": "./src/assets/project_images/accommodation/SilksClub.jpg",
	"./cityRestHilai.jpg": "./src/assets/project_images/accommodation/cityRestHilai.jpg",
	"./cityRestSunshine.jpg": "./src/assets/project_images/accommodation/cityRestSunshine.jpg",
	"./citysuites.jpg": "./src/assets/project_images/accommodation/citysuites.jpg",
	"./han-hsien.jpg": "./src/assets/project_images/accommodation/han-hsien.jpg",
	"./marriott.jpg": "./src/assets/project_images/accommodation/marriott.jpg",
	"./taiurbanresort.jpg": "./src/assets/project_images/accommodation/taiurbanresort.jpg",
	"./thelees.jpg": "./src/assets/project_images/accommodation/thelees.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/project_images/accommodation sync recursive ^\\.\\/.*$";